export default "__VITE_ASSET__D_A0tdtM__"